import {Component, inject} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  selector: 'rn-create-account-dialog',
  template: `
    <mat-dialog-content class="dialog-content">
      <h1>Do you have a library card yet?</h1>
      <h4 class="secondary-text">If you visited us in person, you may already have a library card number.</h4>
      <mat-divider class="divider"/>
      <div class="flex-row flex-center-end flex-gap-8">
        <button mat-raised-button class="dialog-button cancel-button" (click)="navRegister(false)">No</button>
        <button mat-raised-button color="primary" class="dialog-button confirm-button hide-for-mobile" (click)="navRegister(true)">
          Yes, I have a library card
        </button>
        <button mat-raised-button color="primary" class="dialog-button confirm-button show-for-mobile" (click)="navRegister(true)">
          Yes, I have one
        </button>
      </div>
    </mat-dialog-content>
  `,
  styleUrl: './create-account.dialog.component.scss',
  standalone: false
})
export class CreateAccountDialogComponent {
  private readonly router: Router = inject(Router);
  private readonly dialogRef: MatDialogRef<CreateAccountDialogComponent> = inject(MatDialogRef);

  navRegister(hasCard: boolean): void {
    this.dialogRef.close();
    this.router.navigateByUrl(hasCard ? '/register-existing-card' : '/register');
  }
}
